import { createGlobalStyle } from 'antd-style'

export const CommonGlobalStyle = createGlobalStyle(() => ({
  /* -------------------------------------------------------------------------- */
  /*                                CarouselArrow                               */
  /* -------------------------------------------------------------------------- */
  [`.slick-slider:hover .carousel-arrow`]: {
    opacity: 1,
    pointerEvents: 'auto'
  }
}))
